import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)(({ theme }) => ({
  padding: '30px',
  background:
    'linear-gradient(to bottom, rgba(0, 45, 28, 1), rgba(3, 12, 22, 1))',
  height: '100vh',

  [theme.breakpoints.down('sm')]: {
    background: 'white',
  },
}));
